var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.52 9.73672C23.6994 9.27695 23.8 8.77422 23.8 8.25C23.8 5.97266 21.9187 4.125 19.6 4.125C18.7381 4.125 17.9331 4.38281 17.2681 4.82109C16.0562 2.75859 13.7944 1.375 11.2 1.375C7.3325 1.375 4.2 4.45156 4.2 8.25C4.2 8.36602 4.20437 8.48203 4.20875 8.59805C1.75875 9.44453 0 11.7391 0 14.4375C0 17.8535 2.82187 20.625 6.3 20.625H22.4C25.4931 20.625 28 18.1629 28 15.125C28 12.4652 26.075 10.2438 23.52 9.73672ZM17.2113 12.375H14.35V17.1875C14.35 17.5656 14.035 17.875 13.65 17.875H11.55C11.165 17.875 10.85 17.5656 10.85 17.1875V12.375H7.98875C7.36313 12.375 7.0525 11.6359 7.49438 11.202L12.1056 6.67305C12.3769 6.40664 12.8231 6.40664 13.0944 6.67305L17.7056 11.202C18.1475 11.6359 17.8325 12.375 17.2113 12.375Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.adf9446c9babe7e11177071f7ef1e6fd.svg";
export { ForwardRef as ReactComponent };